export const home = {
  // Hero
  hero_eyebrow: 'UNABH\u00c4NGIGER LEITFADEN \u2022 AKTUALISIERT 2026',
  hero_h1: 'CSSBuy Spreadsheet: Produkte, Links und CSSBuy-Leitf\u00e4den finden',
  hero_description: 'Erkunden Sie einen unabh\u00e4ngigen CSSBuy Spreadsheet-Leitfaden mit organisierten Produkten, Kategorien, QC-Informationen, Versand, Bewertungen, Vergleichen und praktischen Tipps f\u00fcr K\u00e4ufer.',
  hero_cta_primary: 'CSSBuy Spreadsheet erkunden',
  hero_cta_secondary: 'CSSBuy-Leitf\u00e4den ansehen',
  hero_trust: 'Unabh\u00e4ngige Information \u2022 Praktische Leitf\u00e4den \u2022 Organisierter Inhalt',

  // Categories
  categories_title: 'Beliebte CSSBuy Spreadsheet Kategorien',
  categories_cta: 'Produkte ansehen',
  cat_shoes: 'Schuhe',
  cat_hoodies: 'Hoodies/Pullover',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jacken',
  cat_pants: 'Hosen/Shorts',
  cat_headwear: 'Kopfbedeckung',
  cat_sets: 'Sets',
  cat_underwear: 'Unterw\u00e4sche',
  cat_jersey: 'Trikots',
  cat_accessories: 'Accessoires',
  cat_bags: 'Taschen',
  cat_belts: 'G\u00fcrtel',
  cat_perfumes: 'Parf\u00fcms',
  cat_other: 'Sonstiges',

  // What is
  whatis_title: 'Was ist das CSSBuy Spreadsheet?',
  whatis_text: 'Das CSSBuy Spreadsheet ist eine organisierte M\u00f6glichkeit, Produkte, Links und Ressourcen im Zusammenhang mit CSSBuy zu entdecken und zu vergleichen. Anstatt Informationen auf verschiedenen Seiten zu suchen, k\u00f6nnen Sie Kategorien erkunden, QC-Leitf\u00e4den konsultieren und n\u00fctzliche Informationen \u00fcber Versand und Kauf an einem Ort finden.',
  whatis_cta: 'Spreadsheet erkunden',

  // How it works
  howitworks_title: 'So verwenden Sie das CSSBuy Spreadsheet',
  step1_title: 'Suchen',
  step1_desc: 'Finden Sie eine Kategorie oder ein Produkt.',
  step2_title: 'Vergleichen',
  step2_desc: 'Vergleichen Sie verf\u00fcgbare Informationen und Links.',
  step3_title: '\u00dcberpr\u00fcfen',
  step3_desc: '\u00dcberpr\u00fcfen Sie Verk\u00e4ufer, Preis, Optionen und QC.',
  step4_title: 'Entscheiden',
  step4_desc: 'F\u00fchren Sie Ihre eigene \u00dcberpr\u00fcfung durch, bevor Sie kaufen.',

  // Guides
  guides_title: 'Beliebteste CSSBuy-Leitf\u00e4den',
  guide_review: 'CSSBuy Review',
  guide_shipping: 'CSSBuy Shipping Cost',
  guide_warehouse: 'CSSBuy Warehouse',
  guide_qc: 'CSSBuy QC',
  guide_coupon: 'CSSBuy Coupon',
  guide_legit: 'CSSBuy Legit',

  // Safety
  safety_title: 'CSSBuy Sicherheitszentrum',
  safety_notice: 'WICHTIGER SICHERHEITSHINWEIS',
  safety_disclaimer: 'Dies ist eine unabh\u00e4ngige Informationswebsite. Sie ist nicht die offizielle CSSBuy-Website. Wir verarbeiten keine Zahlungen, Bestellungen, R\u00fcckerstattungen oder Versand.',
  safety_verify_urls: 'URLs \u00fcberpr\u00fcfen',
  safety_verify_sellers: 'Verk\u00e4ufer \u00fcberpr\u00fcfen',
  safety_verify_price: 'Aktuellen Preis \u00fcberpr\u00fcfen',
  safety_verify_qc: 'QC \u00fcberpr\u00fcfen',
  safety_verify_shipping: 'Versand \u00fcberpr\u00fcfen',
  safety_payments: 'Verd\u00e4chtige Zahlungen vermeiden',
  safety_passwords: 'Passw\u00f6rter nicht teilen',
  safety_customs: 'Zollregeln \u00fcberpr\u00fcfen',
  safety_small_orders: 'Mit kleinen Bestellungen beginnen',

  // Featured
  featured_title: 'Ausgew\u00e4hltes CSSBuy Spreadsheet',
  featured_product: 'Produkt',
  featured_category: 'Kategorie',
  featured_platform: 'Plattform',
  featured_seller: 'Verk\u00e4ufer',
  featured_qc: 'QC',
  featured_updated: 'Aktualisiert',
  featured_action: 'Aktion',
  featured_verify: 'Aktuelle Informationen \u00fcberpr\u00fcfen',
  featured_cta: 'Alle Produkte ansehen',

  // FAQ
  faq_title: 'H\u00e4ufig gestellte Fragen',
  faq_q1: 'Was ist CSSBuy Spreadsheet?',
  faq_a1: 'CSSBuy Spreadsheet ist ein organisierter Leitfaden f\u00fcr Ressourcen, Produkte und Links im Zusammenhang mit CSSBuy.',
  faq_q2: 'Wie funktioniert CSSBuy Spreadsheet?',
  faq_a2: 'Sie navigieren durch Kategorien, finden Produkte und Links und konsultieren Kaufanleitungen.',
  faq_q3: 'Ist CSSBuy Spreadsheet kostenlos?',
  faq_a3: 'Ja, dies ist eine kostenlose, unabh\u00e4ngige Informationsressource.',
  faq_q4: 'Wie \u00fcberpr\u00fcfe ich ein CSSBuy-Produkt?',
  faq_a4: 'Konsultieren Sie QC-Leitf\u00e4den und \u00fcberpr\u00fcfen Sie Verk\u00e4ufer vor dem Kauf.',
  faq_q5: 'Ist CSSBuy legitim?',
  faq_a5: 'CSSBuy ist eine bekannte Plattform. \u00dcberpr\u00fcfen Sie immer Verk\u00e4ufer und Links vor dem Kauf.',
  faq_q6: 'Wie funktioniert CSSBuy-Versand?',
  faq_a6: 'Der Versand h\u00e4ngt von Gewicht, Volumen, Zielort und der gew\u00e4hlten Versandlinie ab.',
  faq_q7: 'Wie funktioniert CSSBuy QC?',
  faq_a7: 'QC bedeutet Quality Control. Es ist der Prozess der \u00dcberpr\u00fcfung der Produkte vor dem Versand.',
  faq_q8: 'Wie viel kostet CSSBuy-Versand?',
  faq_a8: 'Die Kosten h\u00e4ngen von verschiedenen Faktoren ab. \u00dcberpr\u00fcfen Sie aktuelle Informationen auf der offiziellen Website.',

  // Final CTA
  final_cta_title: 'Erkunden Sie das CSSBuy Spreadsheet und finden Sie organisierte Leitf\u00e4den und Ressourcen f\u00fcr Ihre Recherche.',
  final_cta_button: 'CSSBuy Spreadsheet erkunden',

  // Buttons
  btn_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  btn_buy_it_now: 'Buy It Now',

  // Footer
  footer_tagline: 'Unabh\u00e4ngige Informationsressource. Nicht mit CSSBuy verbunden oder von CSSBuy unterst\u00fctzt.',
  footer_links: 'Links',
  footer_legal: 'Rechtliches',
  footer_spreadsheet: 'CSSBuy Spreadsheet',
  footer_guides: 'Leitf\u00e4den',
  footer_reviews: 'Bewertungen',
  footer_shipping: 'Versand',
  footer_coupon: 'Gutscheine',
  footer_warehouse: 'Warehouse',
  footer_qc: 'QC',
  footer_safety: 'Sicherheit',
  footer_comparison: 'Vergleich',
  footer_faq: 'FAQ',
  footer_about: '\u00dcber uns',
  footer_contact: 'Kontakt',
  footer_privacy: 'Datenschutz',
  footer_terms: 'Nutzungsbedingungen',
  footer_disclaimer: 'Disclaimer',
  footer_languages: 'Sprachen',
  footer_lang_pt: 'Portugu\u00eas',
  footer_lang_de: 'Deutsch',
  footer_lang_en: 'English',

  // Nav
  nav_spreadsheet: 'Spreadsheet',
  nav_categories: 'Kategorien',
  nav_guides: 'Leitf\u00e4den',
  nav_reviews: 'Bewertungen',
  nav_shipping: 'Versand',
  nav_safety: 'Sicherheit',
  nav_language: 'Sprache',
  nav_home: 'Startseite',
  nav_shopping_guide: 'Kaufberatung',
  mobile_categories_title: 'Kategorien',
  pillar_title: 'CSSBuy Spreadsheet Hauptleitfäden',

  // Search
  search_placeholder: 'Im CSSBuy Spreadsheet suchen...',
  search_filter_category: 'Kategorie',
  search_filter_platform: 'Plattform',
  search_filter_product: 'Produkt',
  search_filter_seller: 'Verk\u00e4ufer',
  search_filter_qc: 'QC',
  search_filter_updated: 'Aktualisiert',
  search_btn: 'Suchen',
  search_find_fast: 'Finden Sie schnell, wonach Sie suchen',

  // Disclaimer
  independent_notice: 'Unabh\u00e4ngige Informationsressource. Nicht die offizielle CSSBuy-Website.',
};